/** Vendor from GET /api/vendors (camelCase). */
export interface VendorDirectoryEntry {
  id: string;
  name: string;
  address: string;
  /** Optional — used for RFQ email invitations. */
  email?: string;
}

export function mapApiVendor(raw: Record<string, unknown>): VendorDirectoryEntry {
  const email = raw.email != null ? String(raw.email).trim() : '';
  return {
    id: String(raw.id ?? ''),
    name: String(raw.name ?? ''),
    address: String(raw.address ?? ''),
    ...(email ? { email } : {})
  };
}
